var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpFromBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.75C15.75 14.0859 16.2969 13.5 17 13.5C17.6641 13.5 18.25 14.0859 18.25 14.75V17.25C18.25 19.3594 16.5703 21 14.5 21H4.5C2.39062 21 0.75 19.3594 0.75 17.25V14.75C0.75 14.0859 1.29688 13.5 2 13.5C2.66406 13.5 3.25 14.0859 3.25 14.75V17.25C3.25 17.9531 3.79688 18.5 4.5 18.5H14.5C15.1641 18.5 15.75 17.9531 15.75 17.25V14.75ZM8.60156 1.39062C9.07031 0.882812 9.89062 0.882812 10.3594 1.39062L15.3594 6.39062C15.8672 6.85938 15.8672 7.67969 15.3594 8.14844C14.8906 8.65625 14.0703 8.65625 13.6016 8.14844L10.75 5.29688V13.5C10.75 14.2031 10.1641 14.75 9.5 14.75C8.79688 14.75 8.25 14.2031 8.25 13.5V5.29688L5.35938 8.14844C4.89062 8.65625 4.07031 8.65625 3.60156 8.14844C3.09375 7.67969 3.09375 6.85938 3.60156 6.39062L8.60156 1.39062Z",
    fill: "#000D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFromBracket);
export default __webpack_public_path__ + "static/media/arrow-up-from-bracket.0f26e55234e7ed6a06ad767f856f1e7d.svg";
export { ForwardRef as ReactComponent };